import CircleIcon from '@mui/icons-material/Circle';
import { Timeline, TimelineItem } from '@mui/lab';
import { Box, Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { ActivityLogDTO, getActivitLogsByClientAndClientContacts } from 'wisestep-api';
import {
  EmptyTeamsAndUsersIcon,
  WsColors,
  WsListingLoader,
  WsTimeLine,
  WsTitleBanner,
  WsTypoColors,
  WsTypoVariants,
  WsTypography,
  formatDateInDayMonthYearTime,
} from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard/NoDataFoundCard';
import { WsActivityProps } from '../ActivityHelper';

const ActivityLogListing = () => {
  const [activityLogData, setActivityLogData] = useState<ActivityLogDTO[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [activityLists, setActivityLists] = useState<WsActivityProps[]>([]);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const response = await getActivitLogsByClientAndClientContacts();
      setActivityLogData(response.data);
      const updatedActivityLists = response.data.map((data) => ({
        activity: (
          <TimelineItem key={data.id}>
            <Grid container>
              <Grid item xs={12}>
                <WsTypography color={WsTypoColors.TERTIARY}>
                  {` At ${formatDateInDayMonthYearTime(data.createdOn.toString())}`}
                </WsTypography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant={WsTypoVariants.SUB_TITLE}>
                  {`${data.field} Category -> ${data.description} client ${data.parentEntitiyName}`}
                </Typography>
              </Grid>
            </Grid>
          </TimelineItem>
        ),
        leftChildren: <CircleIcon sx={{ color: WsColors.TheBlues600 }} fontSize="small" />,
      }));
      setActivityLists(updatedActivityLists);
    };
    fetchData();
    setLoading(false);
  }, []);

  return (
    <Grid>
      <Grid item xs={12} mb={2}>
        <WsTitleBanner title="Activity Logs" backButton={false} />
      </Grid>
      {!loading ? (
        activityLogData && (
          <Grid item xs={12} borderRadius={2} pl={2} sx={{ background: WsColors.White }}>
            <Timeline>
              <Box ml="-100%">
                <WsTimeLine activityList={activityLists} timeLineDotVariant={'outlined'} />
              </Box>
            </Timeline>
          </Grid>
        )
      ) : loading ? (
        <Grid item xs={12}>
          <WsListingLoader />
        </Grid>
      ) : (
        <Grid item xs={12} mt={2}>
          <NoDataFoundCard text="No results found" icon={<EmptyTeamsAndUsersIcon />} />
        </Grid>
      )}
    </Grid>
  );
};
export default ActivityLogListing;
